import BrandsSubscriptionsStore from '../store/schema/BrandsSubscriptionsStore';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { removeSenderFromSubscriptionStore } from '../actions/internalActions';

export default mutator(removeSenderFromSubscriptionStore, actionMessage => {
    const brandsSubscriptionsStore: BrandsSubscriptionsStore = getStore();

    if (actionMessage.isUnsubscribed) {
        brandsSubscriptionsStore.unsubscribedSubscriptions = brandsSubscriptionsStore.unsubscribedSubscriptions.filter(
            subscriptionModel =>
                subscriptionModel.smtpInfo.smtpAddress !== actionMessage.emailAddress
        );
    } else {
        brandsSubscriptionsStore.subscriptions = brandsSubscriptionsStore.subscriptions.filter(
            subscriptionModel =>
                subscriptionModel.smtpInfo.smtpAddress !== actionMessage.emailAddress
        );
    }
});
